import { create } from "zustand";

export type ErrorModalPayload = {
  title?: string;
  message: string;
  code?: number | string;
  detail?: string;
};

type ErrorModalState = {
  isOpen: boolean;
  payload: ErrorModalPayload | null;

  open: (payload: ErrorModalPayload | string) => void;
  close: () => void;
  clear: () => void;
};

export const useErrorModalStore = create<ErrorModalState>((set) => ({
  isOpen: false,
  payload: null,

  open: (payload) =>
    set(() => ({
      isOpen: true,
      payload: typeof payload === "string" ? { message: payload } : payload,
    })),

  close: () => set(() => ({ isOpen: false })),

  clear: () => set(() => ({ isOpen: false, payload: null })),
}));

/**
 * React 컴포넌트 밖(axios 인터셉터 등)에서도 쓰기 편한 헬퍼
 */
export const openGlobalError = (payload: ErrorModalPayload | string) => {
  useErrorModalStore.getState().open(payload);
};

export const closeGlobalError = () => {
  useErrorModalStore.getState().close();
};
